export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex items-start justify-between gap-6 mb-6" data-testid="page-header">
      <div>
        {eyebrow && (
          <div className="text-[11px] tracking-[0.2em] uppercase text-blue-800 font-semibold mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-500 mt-1 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    confirmed: "bg-blue-50 text-blue-700 border-blue-200",
    in_progress: "bg-indigo-50 text-indigo-700 border-indigo-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-slate-100 text-slate-600 border-slate-200",
    draft: "bg-slate-100 text-slate-700 border-slate-200",
    sent: "bg-blue-50 text-blue-700 border-blue-200",
    paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
    overdue: "bg-red-50 text-red-700 border-red-200",
    available: "bg-emerald-50 text-emerald-700 border-emerald-200",
    busy: "bg-amber-50 text-amber-700 border-amber-200",
    off: "bg-slate-100 text-slate-500 border-slate-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span className={`badge-pill ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {String(status).replace("_", " ")}
    </span>
  );
}

export function Empty({ title = "Nothing here yet", hint, action }) {
  return (
    <div className="card-flat p-10 text-center" data-testid="empty-state">
      <div className="font-display text-lg text-slate-900 font-semibold">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function fmtMoney(v) {
  if (v == null) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v);
}

export function fmtDate(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return v;
  }
}
